export interface PatchPilotOffset {
  bottom?: number;
  right?: number;
  left?: number;
}

export interface PatchPilotConfig {
  apiKey: string;
  apiUrl: string;
  user?: {
    email?: string;
    [key: string]: unknown;
  };
  position?: "bottom-right" | "bottom-left";
  offset?: PatchPilotOffset;
  theme?: "light" | "dark" | "auto";
  locale?: "ko" | "en";
}

export interface ResolvedConfig {
  apiKey: string;
  apiUrl: string;
  user: {
    email?: string;
    [key: string]: unknown;
  };
  position: "bottom-right" | "bottom-left";
  offset: PatchPilotOffset;
  theme: "light" | "dark" | "auto";
  locale: "ko" | "en";
}

export const DEFAULT_CONFIG: Pick<
  ResolvedConfig,
  "position" | "offset" | "theme" | "locale" | "user"
> = {
  position: "bottom-right",
  offset: {},
  theme: "light",
  locale: "ko",
  user: {},
};

export function resolveConfig(config: PatchPilotConfig): ResolvedConfig {
  return {
    apiKey: config.apiKey,
    apiUrl: config.apiUrl.replace(/\/+$/, ""),
    user: config.user ?? DEFAULT_CONFIG.user,
    position: config.position ?? DEFAULT_CONFIG.position,
    offset: config.offset ?? DEFAULT_CONFIG.offset,
    theme: config.theme ?? DEFAULT_CONFIG.theme,
    locale: config.locale ?? DEFAULT_CONFIG.locale,
  };
}
